<style lang="scss">
  @use "../../assets/css/design-system/colors";

  a {
    @include colors.color(primary_50);

    &:hover {
      @include colors.color(primary_70);
    }
  }
</style>

<script>
  import Node from "./Node.svelte";

  let { tag, attributes = {}, children = [] } = $props();
</script>

<svelte:element this={tag} {...attributes}>
  {#each children as child}
    {#if typeof child === "string"}
      {child}
    {:else}
      <Node {...child} />
    {/if}
  {/each}
</svelte:element>
